/**
 * Badge type for payment, trust and shipping badges
 */
export type BadgeType =
  | 'trust'
  | 'creditCard'
  | 'bankTransfer'
  | 'standardShipping'
  | 'expressShipping';

/**
 * Composable to get badges/payment icons from Contentful global page settings
 * @param type - The type of badges to retrieve: 'trust', 'creditCard', 'bankTransfer', 'standardShipping', or 'expressShipping'
 * @returns Computed array of payment icons with src and alt properties
 */
export const useBadges = (type: BadgeType = 'trust') => {
  const { $globalPageSettings } = useNuxtApp();

  const paymentIcons = computed(() => {
    let badges;

    // Determine which collection to use based on the type
    switch (type) {
      case 'trust':
        badges =
          $globalPageSettings.value?.shopConfig?.trustBadgesCollection?.items;
        break;
      case 'creditCard':
        badges =
          $globalPageSettings.value?.shopConfig
            ?.creditCardPaymentBadgesCollection?.items;
        break;
      case 'bankTransfer':
        badges =
          $globalPageSettings.value?.shopConfig
            ?.bankTransferPaymentBadgesCollection?.items;
        break;
      case 'standardShipping':
        badges =
          $globalPageSettings.value?.shopConfig
            ?.standardShippingBadgesCollection?.items;
        break;
      case 'expressShipping':
        badges =
          $globalPageSettings.value?.shopConfig?.expressShippingBadgesCollection
            ?.items;
        break;
      default:
        badges =
          $globalPageSettings.value?.shopConfig?.trustBadgesCollection?.items;
    }

    if (!badges || badges.length === 0) {
      return [];
    }

    return badges.map((badge, index) => ({
      src: badge?.image?.url ?? '',
      alt: badge?.altTag ?? '',
      name: badge?.altTag ?? `badge-${index}`
    }));
  });

  return {
    paymentIcons
  };
};
